<template>
  <div>
    <a-card
      :bordered="false"
      :title="id?'编辑模板':'新建模板'"
    >
      <a-button
        slot="extra"
        @click="handleCancel"
        class="mr-10"
      >
        取消
      </a-button>
      <a-button
        slot="extra"
        type="primary"
        :loading="confirmLoading"
        @click="handleSave"
      >
        保存
      </a-button>
      <div style="overflow: auto">
        <div class="box">
          <a-form-model
            ref="form"
            :model="formData"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            class="box-left"
          >
            <div class="form-title">基本信息</div>
            <a-form-model-item
              label="模板名称"
              prop="name"
            >
              <a-input
                v-model="formData.name"
                placeholder="请输入模板名称"
                allowClear
              />
            </a-form-model-item>
            <a-form-model-item
              label="打印方式"
              prop="print_mode"
            >
              <a-radio-group v-model="formData.print_mode" @change="changePrintMode">
                <!-- <a-radio
                  v-for="(item,index) in dict.printModeDict"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </a-radio> -->
                <a-radio :value="2">
                  一页2码
                </a-radio>
                <a-radio :value="3">
                  一页3码
                </a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
              label="纸张尺寸（宽*高）"
              prop="size"
            >
              <a-input
                v-model="formData.size"
                placeholder="宽*高，以*间隔，单位mm"
                allowClear
                :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
              />mm²
            </a-form-model-item>
            <a-form-model-item
              label="标签水平间距"
              prop="space"
              v-if="1==2"
            >
              <a-input
                v-model.number="formData.space"
                placeholder="请输入水平间距"
                allowClear
                :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
              />mm
            </a-form-model-item>
            <a-form-model-item
              label="标签垂直间距"
              prop="gap"
              v-if="1==2"
            >
              <a-input
                v-model.number="formData.gap"
                placeholder="请输入垂直间距"
                allowClear
                :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
              />mm
            </a-form-model-item>
            <div class="form-title">内容配置<span style="margin-left:20px;font-size:14px">模板内的内容尽量不要太靠边</span>
            </div>
            <a-form-model-item
              label="组件"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
            >
              <a-button
                class="mr-10"
                @click="handleAddQrcode"
              >
                <a-icon type="qrcode" />二维码
              </a-button>
              <a-button
                class="mr-10"
                @click="handleAddText"
              >
                <a-icon type="message" />文本
              </a-button>
              <a-button @click="handleAddImg">
                <a-icon type="picture" />图片
              </a-button>
            </a-form-model-item>
            <a-form-model-item
              label="配置"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
            >
              <a-empty v-if="!formData.unit.length">
                <span slot="description">暂无配置，点击组件添加配置</span>
              </a-empty>
              <template v-for="(item, index) in formData.unit">
                <!-- 二维码 -->
                <a-card v-if="item.type==='QRCODE'" :title="`${index+1}. 二维码`" :key="'set'+index" size="small" class="mt-10">
                  <a-button
                    slot="extra"
                    type="primary"
                    title="一页多码可一键复制同个组件，只适用于第一个码的组件"
                    @click="handleCopyComp($event, item, index)"
                    style="margin-right: 15px"
                    v-if="item.cp_show"
                  >
                    一键复制
                  </a-button>
                  <a-button
                    slot="extra"
                    type="delete"
                    @click="handleDelectComp($event, item, index)"
                  >
                    删除
                  </a-button>
                  <a-form-model-item
                    label="位置（左,顶）"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.left'"
                      :rules="[{ required: true, message: '左距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.left"
                        placeholder="左"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                    <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
                      -
                    </span>
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.top'"
                      :rules="[{ required: true, message: '顶距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.top"
                        placeholder="顶"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    label="大小（宽,高）"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.width'"
                      :rules="[{ required: true, message: '宽必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.width"
                        placeholder="宽"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                    <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
                      -
                    </span>
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.height'"
                      :rules="[{ required: true, message: '高必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.height"
                        placeholder="高"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                  </a-form-model-item>
                </a-card>
                <!-- 文本 -->
                <a-card v-if="item.type==='TEXT'" :title="`${index+1}. 文本`" :key="'set'+index" size="small" class="mt-10">
                  <a-button
                    slot="extra"
                    type="primary"
                    title="一页多码可一键复制同个组件，只适用于第一个码的组件"
                    @click="handleCopyComp($event, item, index)"
                    style="margin-right: 15px"
                    v-if="item.cp_show"
                  >
                    一键复制
                  </a-button>
                  <a-button
                    slot="extra"
                    type="delete"
                    @click="handleDelectComp($event, item, index)"
                  >
                    删除
                  </a-button>
                  <!-- 文本 布局 -->
                  <a-form-model-item
                    label="位置（左,顶）"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.left'"
                      :rules="[{ required: true, message: '左距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.left"
                        placeholder="左"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                    <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
                      -
                    </span>
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.top'"
                      :rules="[{ required: true, message: '顶距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.top"
                        placeholder="顶"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                  </a-form-model-item>
                  <!-- 文本 文字 -->
                  <a-form-model-item
                    label="字体大小（mm）"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                    :prop="'unit.' + index + '.font_size'"
                    :rules="[{ required: true, message: '字体大小必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                  >
                    <a-input
                      v-model.number="item.font_size"
                      @change="is360(item.font_size, index)"
                      placeholder="字体大小（mm）"
                    />
                  </a-form-model-item>
                  <a-form-model-item
                    label="选择字段"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-select
                      v-model="item.goods_field"
                      allowClear
                      placeholder="选择字段"
                      @change="changeGoodsField($event, item, index)"
                    >
                      <a-select-option
                        v-for="field in dict.goodsFieldDict"
                        :key="field.id"
                        :value="field.id"
                      >{{ field.name }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item
                    label="文本"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                    :prop="'unit.' + index + '.text'"
                    :rules="{ required: true, message: '文本必填', trigger: 'blur'}"
                    help="若已有选择字段，则实际打印会显示字段值"
                  >
                    <a-input
                      v-model="item.text"
                      placeholder="请输入文本"
                      allowClear
                    />
                  </a-form-model-item>
                </a-card>
                <!-- ============== 图片 ==============-->
                <a-card v-if="item.type==='PIC'" :title="`${index+1}. 图片`" :key="'set'+index" size="small" class="mt-10">
                  <a-button
                    slot="extra"
                    type="primary"
                    title="一页多码可一键复制同个组件，只适用于第一个码的组件"
                    @click="handleCopyComp($event, item, index)"
                    style="margin-right: 15px"
                    v-if="item.cp_show"
                  >
                    一键复制
                  </a-button>
                  <a-button
                    slot="extra"
                    type="delete"
                    @click="handleDelectComp($event, item, index)"
                  >
                    删除
                  </a-button>
                  <a-form-model-item
                    label="位置（左,顶）"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.left'"
                      :rules="[{ required: true, message: '左距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.left"
                        placeholder="左"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                    <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
                      -
                    </span>
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.top'"
                      :rules="[{ required: true, message: '顶距必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.top"
                        placeholder="顶"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    label="大小(宽,高)"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                  >
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.width'"
                      :rules="[{ required: true, message: '宽必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.width"
                        placeholder="宽"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                    <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }">
                      -
                    </span>
                    <a-form-model-item
                      :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
                      :prop="'unit.' + index + '.height'"
                      :rules="[{ required: true, message: '高必填', trigger: 'blur'},{ message: '请输入数字类型', type:'number', trigger: 'blur'}]"
                    >
                      <a-input
                        v-model.number="item.height"
                        placeholder="高"
                        :style="{ display: 'inline-block', width: 'calc(100% - 30px)' }"
                      />mm
                    </a-form-model-item>
                  </a-form-model-item>
                  <a-form-model-item
                    label="图片"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 16 }"
                    :prop="'unit.' + index + '.picture'"
                    :rules="{ required: true, message: '图片必填', trigger: 'blur'}"
                    help="仅支持bmp格式，使用画图工具转换成单色位图（*.bmp）再上传"
                  >
                    <up-load
                      v-model="item.picture"
                      :onlyBmp="true"
                    />
                  </a-form-model-item>
                </a-card>
              </template>
            </a-form-model-item>
          </a-form-model>
          <div class="box-right">
            <div class="form-title">效果图
            </div>
            <div class="print-des">
              纸张尺寸：{{ pageW }}mm * {{ pageH }}mm；<br>
              水平间距：{{ formData.space }}mm；<br>
              垂直间距：{{ formData.gap }}mm；<br>
              一码大小：{{ oneCodeW }}mm * {{ pageH }}mm
            </div>
            <div
              id="printContent"
              class="print-box"
            >
              <div
                id="printMould"
                :style="{'position':'relative','overflow':'hidden','word-break':'break-all','background': '#999','color':'#000','width':`${pageW*multiple}px`, 'height':`${pageH*multiple}px`, 'display': 'flex', 'justify-content': 'space-between'}"
              >
                <div
                  v-for="index of formData.print_mode"
                  :key="index"
                  :style="{'overflow':'hidden','box-sizing':'border-box', 'background': '#fff','width':`${oneCodeW*multiple}px`, 'height':`${pageH*multiple}px`}"
                ></div>
                <template v-for="(item, index) in formData.unit">
                  <!-- 二维码 -->
                  <img
                    v-if="item.type==='QRCODE'"
                    :key="'comp'+index"
                    :src="item.picture"
                    class="comp"
                    :style="{'width':`${item.width*multiple}px`,'height':`${item.height*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`}"
                    v-drag="item"
                  />
                  <!-- 图片 -->
                  <img
                    v-if="item.type==='PIC'"
                    :key="'comp'+index"
                    :src="item.picture"
                    class="comp"
                    :style="{'width':`${item.width*multiple}px`,'height':`${item.height*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`}"
                    v-drag="item"
                  />
                  <!-- 文本 -->
                  <div
                    v-if="item.type==='TEXT'"
                    :key="'comp'+index"
                    class="comp"
                    :style="{'font-size':`${item.font_size*multiple}px`, 'top':`${item.top*multiple}px`, 'left':`${item.left*multiple}px`, 'white-space': 'nowrap','min-width': '40px', 'min-height': '24px', 'background': '#fff', 'border': '1px solid #ccc'}"
                    v-drag="item"
                  ><span :style="{'zoom':`${item.zoom}`}">{{ item.text }}</span></div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-card>
    <!-- 打印服务 -->
    <print-service
      ref="PrintService"
      :printData="{
        unit: [formData.unit],
        size: formData.size,
        gap: formData.gap
      }"
    />
  </div>
</template>
<script>
import PrintService from '@/components/PrintService'
import UpLoad from '@/components/UpLoad'
import { deepClone, formatPath } from '@/utils'
import { getTemplatePre, getTemplateDetail, postTemplateAdd, postTemplateEdit } from '@/api/print'

const multiple = 5 // px与mm转化倍数
const defaultFormData = {
  name: '',
  print_mode: 3,
  size: '94*25', // '62*25'
  space: 2,
  gap: 2,
  unit: [
  ]
}

const defaultCom = {
  type: 'QRCODE',
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  font_size: 3,
  line_height: 0,
  text: '',
  goods_field: '',
  picture: '',
  sort: 0,
  cp_show: 1
}

const defaultQrcode = Object.assign({}, defaultCom, {
  type: 'QRCODE',
  top: 0,
  left: 0,
  width: 20,
  height: 20,
  picture: 'https://8899-city.oss-cn-shenzhen.aliyuncs.com/code/qrcode_demo.bmp'
})
const defaultText = Object.assign({}, defaultCom, {
  type: 'TEXT', // 组件名
  top: 0,
  left: 0,
  font_size: 3,
  zoom: 1,
  goods_field: '',
  text: ''
})

const defaultImg = Object.assign({}, defaultCom, {
  type: 'PIC',
  top: 0,
  left: 0,
  width: 15,
  height: 15,
  picture: ''
})

export default {
  name: 'MouldForm',
  components: { UpLoad, PrintService },
  data() {
    return {
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      formData: deepClone(defaultFormData),
      rules: {
        name: [{ required: true, message: '模板名称必填', trigger: 'blur' }],
        print_mode: [{ required: true, message: '打印方式必填', trigger: 'change' }],
        size: [{ required: true, message: '纸张尺寸必填', trigger: 'blur' }],
        space: [
          { required: true, message: '水平间距必填', trigger: 'blur' },
          { type: 'number', message: '请输入数字类型', trigger: 'blur' }
        ],
        gap: [
          { required: true, message: '垂直间距必填', trigger: 'blur' },
          { type: 'number', message: '请输入数字类型', trigger: 'blur' }
        ]
      },
      // 字典
      dict: {
        printModeDict: [],
        goodsFieldDict: []
      },
      multiple: multiple // px与mm转化倍数
    }
  },
  directives: {
    drag: {
      // 通过三个鼠标事件：点击、移动、抬起，只要计算出当前位置即可
      inserted: function(el, binding) {
        let x = 0
        let y = 0
        let l = 0
        let t = 0
        let isDown = false

        // 计算移动后的左偏移量和顶部的偏移量
        let nl = 0
        let nt = 0

        // 鼠标按下事件
        el.onmousedown = function(e) {
          // 重要，否则卡顿
          e.preventDefault()

          // 获取x坐标和y坐标
          x = e.clientX
          y = e.clientY

          // 获取左部和顶部的偏移量
          l = el.offsetLeft
          t = el.offsetTop

          // 获取纸张元素
          const obj = document.getElementById('printMould')
          const objRect = obj.getBoundingClientRect()
          const elRect = el.getBoundingClientRect()
          const maxNl = objRect.width - elRect.width
          const maxNt = objRect.height - elRect.height

          // 开关打开
          isDown = true
          // 设置样式
          el.style.cursor = 'move'
          el.style.border = '1px solid blue'
          el.style['z-index'] = 1000

          // 鼠标移动
          window.onmousemove = function(e) {
            if (isDown === false) {
              return
            }

            // 获取x和y
            const nx = e.clientX
            const ny = e.clientY

            // 鼠标不在模板块级元素内部。同抬起鼠标
            if (!(nx > objRect.left && nx < objRect.right && ny > objRect.top && ny < objRect.bottom)) {
              onmouseup()
              return false
            }

            // 计算移动后的左偏移量和顶部的偏移量
            nl = nx - (x - l)
            nt = ny - (y - t)

            // 控制不超出纸张区域
            if (nl < 0) {
              nl = 0
            }
            if (nt < 0) {
              nt = 0
            }

            if (nl > maxNl) {
              nl = maxNl
            }
            if (nt > maxNt) {
              nt = maxNt
            }

            el.style.left = nl + 'px'
            el.style.top = nt + 'px'
          }
          // 鼠标抬起事件
          window.onmouseup = function() {
            onmouseup()
          }
          // 鼠标抬起执行函数
          function onmouseup() {
            // 开关关闭
            isDown = false
            el.style.border = '1px solid #ccc'
            el.style.cursor = 'default'
            el.style['z-index'] = 0
            // 赋值
            binding.value.left = Number((nl / multiple).toFixed(1))
            binding.value.top = Number((nt / multiple).toFixed(1))
            window.onmousemove = null
            window.onmouseup = null
          }
        }
      }
    }
  },
  computed: {
    pageW() {
      const sizeArr = this.formData.size.split('*')
      return parseFloat(sizeArr[0]) || 0
    },
    pageH() {
      const sizeArr = this.formData.size.split('*')
      return parseFloat(sizeArr[1]) || 0
    },
    oneCodeW() {
      return ((this.pageW - this.formData.space * (this.formData.print_mode - 1)) / this.formData.print_mode).toFixed(1)
    }
  },
  created() {
    this.id = this.$route.query && this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      // 编辑
      this.getDetail()
    } else {
      this.formData = Object.assign({}, defaultFormData)
    }
    this.getPre()
  },
  methods: {
    changePrintMode() {
      if (this.formData.print_mode === 2) {
        this.formData.size = '92*35'
      }
      if (this.formData.print_mode === 3) {
        this.formData.size = '94*25'
      }
    },
    // 选择字段
    changeGoodsField($event, item, index) {
      this.formData.unit[index].text = `#${item.goods_field}#`
    },
    print() {
      const printHtml = document.getElementById('printContent').innerHTML // 需要打印的内容
      const newWin = window.open('', '_blank')
      newWin.document.write(
        '<html><head><title>打印模板</title><style>*{margin:0;padding:0}.comp {position: absolute;overflow: hidden;z-index: 1;user-select: none;}</style></head><body>'
      )
      newWin.document.write(printHtml)
      newWin.document.write('</body></html>')
      newWin.print()
      newWin.close() // 打印完成后关闭
    },
    // 添加二维码
    handleAddQrcode() {
      this.formData.unit.push(Object.assign({}, defaultQrcode))
    },
    // 添加文本
    handleAddText() {
      this.formData.unit.push(Object.assign({}, defaultText))
    },
    // 添加图片
    handleAddImg() {
      this.formData.unit.push(Object.assign({}, defaultImg))
    },
    // 删除组件
    handleDelectComp(event, item, index) {
      event.stopPropagation()
      this.$confirm({
        title: '确定要删除该组件?',
        onOk: () => {
          this.formData.unit.splice(index, 1)
        }
      })
    },
    // 复制组件
    handleCopyComp(event, item, index) {
      var mode = this.formData.print_mode
      item.cp_show = 0
      const item_new = deepClone(item)

      for (var i = 1; i < mode; i++) {
        var singleL = (parseFloat(this.oneCodeW) + 2) * i
        item_new.left = item.left + singleL

        if (item.type === 'TEXT') {
          this.formData.unit.push(Object.assign({}, defaultText, item_new))
        } else if (item.type === 'PIC') {
          this.formData.unit.push(Object.assign({}, defaultImg, item_new))
        } else {
          this.formData.unit.push(Object.assign({}, defaultQrcode, item_new))
        }
      }
    },
    // 保存
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const mode = this.formData.print_mode
          if (mode === 3) {
            const unit = this.formData.unit
            var num = 0
            for (var i = 0; i < unit.length; i++) {
              if (unit[i].goods_field === 'sc_id') {
                num++
              }
            }
            if (num === 2) {
              this.$message.error('序列号数必须和云码数一致！')
              return false
            }
          }
          if (this.id) {
            // 编辑
            this.postEdit()
          } else {
            // 新增
            this.postAdd()
          }
        } else {
          this.$message.error('还有字段未填写，请检查！')
          return false
        }
      })
    },
    // 点击 取消 按钮
    handleCancel() {
      this.$router.go(-1)
    },
    // 预加载
    getPre() {
      getTemplatePre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.printModeDict = data.printModeDict
            this.dict.goodsFieldDict = data.goodsFieldDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 转换成接口所需参数
    paramsFormat() {
      const unit = deepClone(this.formData.unit)
      unit.forEach((element) => {
        return element.picture && (element.picture = formatPath(element.picture))
      })
      return Object.assign({}, this.formData, { unit })
    },
    // 编辑
    postEdit() {
      this.confirmLoading = true
      postTemplateEdit(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.getDetail()
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 新增
    postAdd() {
      this.confirmLoading = true
      postTemplateAdd(this.paramsFormat())
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('保存成功')
            this.handleCancel()
          }
        })
        .catch((e) => {
          this.$message.error('保存失败')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 详情
    getDetail() {
      getTemplateDetail({
        template_id: this.id
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.formData = {
              template_id: data.template_id,
              name: data.name,
              print_mode: data.print_mode,
              size: data.size,
              space: data.space,
              gap: data.gap,
              unit: deepClone(data.unit || [])
            }
            // 判断是否有小于12px的字体
            var unit = data.unit
            for (var i = 0; i < unit.length; i++) {
              var _i = unit[i]
              if (_i.type === 'TEXT' && _i.font_size < 2.4) {
                this.is360(_i.font_size, i)
              }
            }
          }
        })
        .catch((e) => {
          this.$message.error('请求详情失败')
        })
    },
    // 打开打印服务
    handlePrint() {
      this.$refs.PrintService.showModal()
    },
    // 兼容360和谷歌字体不能小于12px的问题
    is360(size, index) {
      var userAgent = navigator.userAgent
      var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1
      // 判断是否是谷歌
      if (isChrome) {
        if (size < 2.4) {
          var _zoom = size * 5 / 12
          this.formData.unit[index].zoom = _zoom
        } else {
          this.formData.unit[index].zoom = 1
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.form-title {
  background: transparent;
  padding: 24px 0;
  zoom: 1;
  margin-bottom: -1px;
  min-height: 48px;
  font-size: 16px;
  color: @heading-color;
  font-weight: 500;
}
.pr {
  position: relative;
}
// .print-mould {
//   position: absolute;
//   top: 50%;
//   left: 530px;
//   transform: translateY(-50%);
//   overflow: auto;
//   // padding: 50px;
//   box-sizing: border-box;
//   padding: 0 30px 30px 30px;
//   background: rgba(0, 0, 0, 0.2);
// }
.print-box {
  display: inline-block;
  overflow: auto;
  box-sizing: border-box;
  // padding: 20px 0;
  // background: rgba(0, 0, 0, 0.1);
  max-width: 100%;
}
.print-des {
  margin-bottom: 10px;
}
.box {
  display: flex;
  // min-width: 900px;
}
.box-left {
  // flex: 0 1 600px;
  // min-width: 360px;
  width: 600px;
}
.box-right {
  flex-grow: 1;
  padding: 0 30px 30px 30px;
  position: fixed;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.2);
  // max-width: calc(100% - 500px);
}

.comp {
  position: absolute;
  overflow: hidden;
  user-select: none;
  z-index: 0;
}
</style>
